import { propertyPresets } from '@blocksuite/data-view/property-presets';

import { createdTimeColumnConfig } from './created-time/cell-renderer.js';
import { linkColumnConfig } from './link/cell-renderer.js';
import { relationColumnConfig } from './relation/cell-renderer.js';
import { richTextColumnConfig } from './rich-text/cell-renderer.js';
import { rollupColumnConfig } from './rollup/cell-renderer.js';
import { rowNumberColumnConfig } from './row-number/cell-renderer.js';
import { titleColumnConfig } from './title/cell-renderer.js';

export * from './converts.js';
export * from './relation/index.js';
export * from './rollup/index.js';
const {
  checkboxPropertyConfig,
  datePropertyConfig,
  dateRangePropertyConfig,
  formulaPropertyConfig,
  multiSelectPropertyConfig,
  numberPropertyConfig,
  progressPropertyConfig,
  selectPropertyConfig,
} = propertyPresets;
export const databaseBlockProperties = {
  checkboxColumnConfig: checkboxPropertyConfig,
  dateColumnConfig: datePropertyConfig,
  dateRangeColumnConfig: dateRangePropertyConfig,
  multiSelectColumnConfig: multiSelectPropertyConfig,
  numberColumnConfig: numberPropertyConfig,
  progressColumnConfig: progressPropertyConfig,
  selectColumnConfig: selectPropertyConfig,
  imageColumnConfig: propertyPresets.imagePropertyConfig,
  linkColumnConfig,
  richTextColumnConfig,
  titleColumnConfig,
  createdTimeColumnConfig,
  relationColumnConfig,
  rollupColumnConfig,
  rowNumberColumnConfig,
  formulaColumnConfig: formulaPropertyConfig,
};
